export default {
  name: 'input',
  type: 'action',
  isRequired: true,
  essential: false
}
